/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./httpClient";

export class Env<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Return the environment meta data
   *
   * @tags Environment
   * @name GetEnv
   * @summary Environment metadata
   * @request GET:/env
   * @secure
   */
  getEnv = (params: RequestParams = {}) =>
    this.request<
      {
        productMode: string;
        logoPublicUrl: string;
        headerLogoPublicUrl: string;
        coverImagePublicUrl: string;
        publicEmail: string;
        disclaimer: string;
        address: string;
        region: string;
        domain: string;
        tenantName: string;
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/env`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
